<template>
  <div>
    <TextInput :noLabel="true" v-model="templateString" id="template-string" />
    <div>
      <i>{{ value ? "Example" : "Default" }}:</i> {{ sampleString }}
    </div>
    <div>
      <button
        class="m-1"
        v-for="token of tokens"
        v-bind:key="token"
        @click="handleClickToken(token)"
      >
        {{ tokenDisplay(token) }}
      </button>
    </div>
  </div>
</template>

<script>
import { getPdfFileName } from "@/modules/helpers";
import TextInput from "./common/TextInput.vue";
import { startCase } from "lodash";

export default {
  props: ["value"],
  components: { TextInput },
  data() {
    return {
      tokens: [
        "CurrentDate",
        "FullCaseNumber",
        "ShortCaseNumber",
        "PatientFirstName",
        "PatientFirstInitial",
        "PatientLastName",
        "ProviderFirstName",
        "ProviderLastName"
      ]
    };
  },
  computed: {
    templateString: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    },
    sampleString() {
      return getPdfFileName(
        {
          accessionNumber: "T2025-0012345",
          patientFirstName: "John",
          patientLastName: "Smith",
          providerFirstName: "Jane",
          providerLastName: "Jones"
        },
        null,
        this.templateString
      );
    }
  },
  methods: {
    tokenDisplay(token) {
      return startCase(token);
    },
    handleClickToken(token) {
      const inputEl = document.getElementById("template-string");
      const { selectionStart, selectionEnd } = inputEl;
      let newString = "";
      if (!this.templateString) {
        newString = `{${token}}`;
      } else {
        newString = `${this.templateString.slice(
          0,
          selectionStart
        )}{${token}}${this.templateString.slice(selectionEnd)}`;
      }
      this.templateString = newString;
      inputEl.focus();
      const selectionIndex = selectionStart + token.length + 2;
      this.$nextTick(() => {
        inputEl.setSelectionRange(selectionIndex, selectionIndex);
      });
    }
  }
};
</script>

<style lang="scss" scoped></style>
